<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-content width="1100px">
		<kaveh-form :key="ver" :entity="entity" :task="submit" />
	</kaveh-content>
</template>
<script>
	import { StaticContent } from '@/modules/cms/data/static-content/create'
	import { StaticContentService } from '@/modules/cms/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed: 
		{
			entity()
			{
				return StaticContent
			},
			service()
			{
				return new StaticContentService()
			},
		},
		methods:
		{
			async submit(payload)
			{
				try
				{
					const res = await this.service.create(payload);
					if (res.status == 200)
					{
						this.ver += 1
					}

				} catch (e) { console.log(e) }
			}
		}
	}
</script>